import {
  resetUploadStatus,
  uploadKTP,
} from "features/common/layouts/cartSlice";
import { fileToBase64 } from "helpers/helper";
import { useCallback, useEffect, useRef, useState } from "react";
import { Modal, Spinner } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import Webcam from "react-webcam";
import { notifyError } from "components/ToastMessage";

const videoConstraints = {
  width: 500,
  height: 400,
  facingMode: "user",
};

const ModalUploadImage = (props) => {
  const dispatch = useDispatch();
  const { uploadStatus, code, message } = useSelector(
    (state) => state.cart.ktpCard
  );
  const inputFileRef = useRef(null);
  const webcamRef = useRef(null);
  const uploadBtnRef = useRef(null);

  const [thumbnailImg, setThumbnailImg] = useState(null);
  const [rawFiles, setRawFiles] = useState(null);
  const [useCamera, setUseCamera] = useState({
    title: "Buka Kamera",
    status: false,
  });
  const [disableUploadBtn, setDisableUploadBtn] = useState(true);

  useEffect(() => {
    setDisableUploadBtn(rawFiles ? false : true);
  }, [rawFiles]);

  useEffect(() => {
    setDisableUploadBtn(false);
    const timer = setTimeout(() => {
      if (uploadStatus === "user_agree") {
        props.handler(false);
      } else {
        dispatch(resetUploadStatus("waiting"));
      }
    }, 500);

    return () => {
      clearTimeout(timer);
    };
  }, [uploadStatus, props, dispatch]);

  const captureCam = useCallback(() => {
    const imageSrc = webcamRef.current.getScreenshot();
    setThumbnailImg(imageSrc);
    setRawFiles(imageSrc);
    setUseCamera({
      title: "Buka Kamera",
      status: false,
    });
  }, [webcamRef]);

  const selectImageHandle = () => {
    inputFileRef.current.click();
  };

  const useCameraHandle = () => {
    if (!useCamera.status) {
      setThumbnailImg(null);
      setUseCamera({ title: "Tutup Kamera", status: true });
    } else {
      setUseCamera({ title: "Buka Kamera", status: false });
    }
  };

  const getImage = async (e) => {
    const { length: filesLength } = e.target.files;

    if (filesLength > 0) {
      const fileData = e.target.files[0];
      const thumbnail = await fileToBase64(fileData);
      setRawFiles(fileData);
      setThumbnailImg(thumbnail);
    }
  };

  const clearImageHandler = () => {
    setRawFiles(null);
    setThumbnailImg(null);
    inputFileRef.current.value = "";
  };

  const uploadImageHandler = async (e) => {
    if (typeof rawFiles === "string") {
      // rawFiles is in base64 format, directly send it
      setDisableUploadBtn(true);
      dispatch(uploadKTP(rawFiles));
    } else {
      if (rawFiles.size > 2 * 1024 * 1024) {
        notifyError(
          "Harap periksa ukuran file Anda. Ukuran maksimal yang diperbolehkan adalah 2MB."
        );
        return;
      }

      if (
        rawFiles.type !== "image/jpg" &&
        rawFiles.type !== "image/png" &&
        rawFiles.type !== "image/jpeg"
      ) {
        notifyError(
          "Maaf, hanya file dengan ekstensi PNG, JPG, dan JPEG yang diperbolehkan."
        );
        return;
      }

      setDisableUploadBtn(true);
      dispatch(uploadKTP(rawFiles));
    }
  };

  const uploadLaterHandler = () => {
    dispatch(resetUploadStatus("user_agree"));
  };
  return (
    <Modal show={props.show} onHide={props.onHide} dialogClassName="modal-90w">
      <Modal.Header closeButton>
        <h6 className="mb-0">
          Upload Foto Selfie dengan KTP/SIM/KITAS/Passport
        </h6>
      </Modal.Header>
      <Modal.Body className="pb-0">
        <div
          className={`img-wrapper ${
            thumbnailImg && "border border-2 border-success"
          } mx-auto `}
          onClick={selectImageHandle}
        >
          <input
            ref={inputFileRef}
            name="image-ktp"
            type="file"
            className="d-none"
            onChange={getImage}
            accept="image/*"
          />
          {!thumbnailImg && !useCamera.status && (
            <div className="text-center">
              Upload disini
              <p className="mt-2" style={{ fontSize: "12px" }}>
                {" "}
                <i>File: Maks. 2MB, tipe yang diperbolehkan: PNG, JPG, JPEG.</i>
              </p>
            </div>
          )}
          {thumbnailImg && (
            <img
              src={thumbnailImg}
              alt={`user_ktp_${Math.floor(Math.random() * 900) + 100}`}
            />
          )}
          {useCamera.status && (
            <Webcam
              audio={false}
              height={500}
              ref={webcamRef}
              screenshotFormat="image/jpeg"
              width={400}
              videoConstraints={videoConstraints}
            />
          )}
        </div>
        <div className="d-flex justify-content-between my-2">
          <button
            className="btn btn-outline-secondary btn-sm d-flex align-items-center"
            type="button"
            onClick={useCameraHandle}
          >
            {useCamera.title}
          </button>
          {rawFiles && !useCamera.status && (
            <button
              className="btn btn-link m-0 p-0 text-danger text-decoration-none"
              onClick={clearImageHandler}
            >
              Hapus
            </button>
          )}
          {useCamera.status && (
            <button className="btn btn-success btn-sm" onClick={captureCam}>
              Capture
            </button>
          )}
        </div>
      </Modal.Body>
      <Modal.Footer className="justify-content-center">
        <small className="text-qw-primary">
          *Lengkapi syarat pendaftaran paling lambat 3x24 jam setelah memesan
          layanan, Baca ketentuan lengkap di
          <a
            href={`${process.env.REACT_APP_QWORDS_API}master-service-agreement/term-of-service/?_gl=1*1gc74x2*_gcl_aw*R0NMLjE2NzQwOTQyNTQuQ2p3S0NBaUF6cDZlQmhCeUVpd0FfZ0dxNUNid083RGt4Z2M5V00waXd2M2p5NE94bkpZTjhxOVpRMVJpZHlZYU1WRHUtRFUxSVVHdTBCb0NQdmtRQXZEX0J3RQ..&_ga=2.209351954.1691100910.1676855061-648682774.1669949929&_gac=1.120643962.1674094254.CjwKCAiAzp6eBhByEiwA_gGq5CbwO7Dkxgc9WM0iwv3jy4OxnJYN8q9ZQ1RidyYaMVDu-DU1IUGu0BoCPvkQAvD_BwE`}
            target="_blank"
            rel="noreferrer"
            className="mx-1"
          >
            Term of Service
          </a>
          Point 13.
        </small>
        <div className="d-flex flex-column align-items-center gap-2">
          {uploadStatus === "fail_upload" && code === 400 && (
            <div className="text-danger">{message} Gagal Upload!</div>
          )}
          {uploadStatus === "uploading" && <Spinner />}
          {uploadStatus === "user_agree" && code === 200 && (
            <div className="text-success">File Berhasil diupload!</div>
          )}

          {(!uploadStatus || uploadStatus === "waiting") && (
            <button
              className="btn btn-cta fw-normal"
              type="button"
              onClick={uploadImageHandler}
              ref={uploadBtnRef}
              disabled={disableUploadBtn}
            >
              Upload
            </button>
          )}
          <button
            className="btn btn-link text-primary"
            onClick={uploadLaterHandler}
          >
            Upload nanti
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalUploadImage;
